import { render, staticRenderFns } from "./contract-trade.vue?vue&type=template&id=588f807c&"
import script from "./contract-trade.vue?vue&type=script&lang=js&"
export * from "./contract-trade.vue?vue&type=script&lang=js&"
import style0 from "./contract-trade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports